import { Injectable, signal } from '@angular/core';

const CHAVE_TEMA = 'PREVIMIL_TEMA';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  escuro = signal<boolean>(this.lerPreferenciaSalva());

  constructor() {
    this.aplicarTema(this.escuro());
  }

  private lerPreferenciaSalva(): boolean {
    try {
      return localStorage.getItem(CHAVE_TEMA) === 'escuro';
    } catch {
      return false;
    }
  }

  alternar() {
    this.definir(!this.escuro());
  }

  definir(escuro: boolean) {
    this.escuro.set(escuro);
    this.aplicarTema(escuro);
    try {
      localStorage.setItem(CHAVE_TEMA, escuro ? 'escuro' : 'claro');
    } catch {
      // localStorage indisponível (ex: navegação privada) — preferência não persiste, mas app segue funcionando
    }
  }

  private aplicarTema(escuro: boolean) {
    const raiz = document.documentElement;
    if (escuro) {
      raiz.setAttribute('data-theme', 'dark');
      raiz.classList.add('dark'); // classe usada pelo darkMode:"class" do Tailwind
    } else {
      raiz.removeAttribute('data-theme');
      raiz.classList.remove('dark');
    }
  }

}
